import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=1d149c33"
import script from "./OptionSelector.vue?vue&type=script&lang=ts"
export * from "./OptionSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports